import { all, fork } from "redux-saga/effects";
import { standardsSaga } from "pages/teacher/standards/duck";
import { highlightingSaga } from "components/toolbar/components/actions/components/highlighting/duck";
import { toolbarSaga } from "components/toolbar/components/actions/duck";
import { otherScoresSaga } from "../../pages/teacher/students/components/sections/show/components/students/components/table/duck";

export default function* rootSaga(): any {
  yield all([
    fork(standardsSaga),
    fork(highlightingSaga),
    fork(toolbarSaga),
    fork(otherScoresSaga),
  ]);
}
